import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment/moment';
import clsx from 'clsx';
import { AssignmentInd, LocalShippingOutlined as ShippingIcon } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import Tooltip from './Tooltip';
import ButtonLink from '../../../components/ButtonLink';

const useStyles = makeStyles(theme => {
  return {
    shipping: {
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column'
    },
    redText: {
      color: 'darkred'
    },
    greenText: {
      color: 'green'
    },
    boldText: {
      fontWeight: 'bold'
    }
  };
});

const ShippingColumn = ({ shipment, collapsed, onClickTrackingNumber }) => {
  const classes = useStyles();

  if (!shipment) {
    return '';
  }

  const shippingMethod = !!shipment.shipping_method && shipment.shipping_method.name;
  const shipDate = shipment.ship_date;
  const shipDateMoment = moment(shipDate).endOf('day');
  const isPrintCompleted = shipment.completed;
  let shipDateClassName = null;

  if (!isPrintCompleted) {
    if (shipDateMoment.isBefore(moment.now())) {
      shipDateClassName = clsx([classes.redText, classes.boldText]);
    } else if (shipDateMoment.isSame(moment.now(), 'date')) {
      shipDateClassName = clsx([classes.greenText, classes.boldText]);
    }
  }

  return (
    <div className={classes.shipping}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {shipDate && (
          <Tooltip disabled={collapsed} title={shippingMethod}>
            <label className={shipDateClassName}>{shipDate}</label>
          </Tooltip>
        )}

        {shipment.patient_label_printed && (
          <Tooltip disabled={false} title="Patient Label Printed">
            <AssignmentInd fontSize="small" color="primary" />
          </Tooltip>
        )}
        {shipment.shipping_label_printed && (
          <Tooltip disabled={false} title="Shipping Label Printed">
            <ShippingIcon fontSize="small" color="primary" />
          </Tooltip>
        )}
      </div>
      {collapsed && (
        <>
          {shipment.expected_arrival_date && <label>{shipment.expected_arrival_date}</label>}
          <label>{shippingMethod}</label>
          {!isEmpty(shipment.tracking_number) &&
            (onClickTrackingNumber ? (
              <ButtonLink onClick={() => onClickTrackingNumber(shipment.tracking_number)}>
                {shipment.tracking_number}
              </ButtonLink>
            ) : (
              <label>{shipment.tracking_number}</label>
            ))}
        </>
      )}
    </div>
  );
};

ShippingColumn.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  shipment: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  onClickTrackingNumber: PropTypes.func
};

ShippingColumn.defaultProps = {
  shipment: null,
  onClickTrackingNumber: null
};

export default ShippingColumn;
